/**
 * 截断字符串，如果超过指定长度则在末尾添加省略号
 * @param str 要处理的字符串
 * @param maxLength 最大长度，默认38
 * @returns 处理后的字符串
 */
export function truncateString(str: string, maxLength: number = 38): string {
  if (!str) {
    return '';
  }

  if (maxLength === -1) return str;

  // 如果字符串长度小于等于最大长度，直接返回原字符串
  if (str.length <= maxLength) {
    return str;
  }

  // 否则返回前maxLength个字符加上省略号
  return str.substring(0, maxLength) + '...';
}

// 导出默认函数
export default truncateString;